import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'

export interface FormateurDto {
  id: Long | null
  email: string
  login: string
  prenom: string
  nom: string
  telephone: string | null
  photoUrl: string | null
  affectations: AffectationFormateur[]
  structureIds: number[]
  structureNoms: string[]
}

export interface AffectationFormateur {
  dateAffectation: string
  societe: string
}

export interface CreateFormateurRequest {
  prenom: string
  nom: string
  email: string
  telephone?: string
  structureIds?: number[]
}

type Long = number

export const formateursAdminApi = {
  getAll: () =>
    api.get<ApiResponse<FormateurDto[]>>('/api/formateurs').then((r) => r.data.data),

  getById: (id: number) =>
    api.get<ApiResponse<FormateurDto>>(`/api/formateurs/${id}`).then((r) => r.data.data),

  create: (data: CreateFormateurRequest) =>
    api.post<ApiResponse<FormateurDto>>('/api/formateurs/create', data).then((r) => r.data.data),

  update: (id: number, data: FormateurDto) =>
    api.put<ApiResponse<FormateurDto>>(`/api/formateurs/${id}`, data).then((r) => r.data.data),

  delete: (id: number) =>
    api.delete(`/api/formateurs/${id}`),

  resetPassword: (id: number) =>
    api.post<ApiResponse<void>>(`/api/formateurs/${id}/reset-password`).then((r) => r.data),
}
